function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFertilizerX24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2783"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 385",
    d: "M12 0a12 12 0 1 0 12 12A12.035 12.035 0 0 0 12 0z",
    style: {
      fill: "#26791c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2735",
    d: "M25.636 15.1a6.5 6.5 0 0 1-3.091 7.761c-.177.1-.357.179-.537.256a3.9 3.9 0 0 1-.25.759 7.129 7.129 0 0 0 4.525-8.833 5.738 5.738 0 0 0-.646.056",
    transform: "translate(-7.31 -4.6)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2736",
    d: "M12.579 23.823a6.5 6.5 0 0 1-5.171-7.347 3.877 3.877 0 0 1-.525-.6 7.1 7.1 0 0 0 5.434 8.52 5.9 5.9 0 0 0 .262-.572",
    transform: "translate(-1.705 -4.912)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2737",
    d: "M27.022 12.325a3.371 3.371 0 0 0-3.805-1.254 3.366 3.366 0 0 0-1.948 3.492c.03.213.129.332.3.351a.234.234 0 0 0 .036 0 .323.323 0 0 0 .283-.173 5.573 5.573 0 0 1 2.18-1.451.251.251 0 0 0 .041-.016 5.555 5.555 0 0 1 2.588-.4.323.323 0 0 0 .351-.09.351.351 0 0 0-.021-.462m-3.166.375a5.743 5.743 0 0 0-1.514.8 3.288 3.288 0 0 1 2.207-1.407l-.037-.311a3.656 3.656 0 0 0-2.544 1.7 2.5 2.5 0 0 1 1.477-1.826 2.438 2.438 0 0 1 .834-.15 2.821 2.821 0 0 1 1.8.719 6.158 6.158 0 0 0-2.218.475",
    transform: "translate(-7.12 -3.05)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2738",
    d: "M12.18 13.307a.32.32 0 0 0-.307-.191 5.545 5.545 0 0 1-2.347-1.162.372.372 0 0 0-.035-.027 5.552 5.552 0 0 1-1.638-2.043.322.322 0 0 0-.253-.259c-.168-.031-.3.054-.389.252a3.376 3.376 0 0 0 .817 3.92 3 3 0 0 0 1.867.643 3.735 3.735 0 0 0 2.132-.7.347.347 0 0 0 .156-.432m-3.762 0a2.619 2.619 0 0 1-.821-2.562 6.156 6.156 0 0 0 1.521 1.683 5.746 5.746 0 0 0 1.449.911 3.287 3.287 0 0 1-2.32-1.208l-.252.188a3.658 3.658 0 0 0 2.756 1.35 2.506 2.506 0 0 1-2.331-.363",
    transform: "translate(-1.781 -2.582)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2739",
    d: "M17.153 21.994a.346.346 0 0 0-.453.08.323.323 0 0 0-.013.362 5.55 5.55 0 0 1 .168 2.614.259.259 0 0 0-.007.043 5.56 5.56 0 0 1-.947 2.441.323.323 0 0 0-.1.35.329.329 0 0 0 .348.215h.063a3.373 3.373 0 0 0 2.988-2.672 3.366 3.366 0 0 0-2.049-3.433m1.429 3.337a2.618 2.618 0 0 1-1.808 1.993 6.14 6.14 0 0 0 .7-2.158 5.707 5.707 0 0 0 .065-1.711 3.289 3.289 0 0 1 .115 2.614l.288.124a3.658 3.658 0 0 0-.2-3.053 2.5 2.5 0 0 1 .843 2.192",
    transform: "translate(-5.086 -7.172)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2740",
    d: "M17.845 18.936a2 2 0 1 0-.945.239 2 2 0 0 0 .945-.239m-2.154-1.106a1.369 1.369 0 1 1 1.855.554 1.371 1.371 0 0 1-1.855-.554",
    transform: "translate(-4.756 -4.654)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2741",
    d: "M12.67 7.611a7.1 7.1 0 0 0-2.843 1.835 5.726 5.726 0 0 0 .378.518 6.225 6.225 0 0 1 2.814-1.8 2.524 2.524 0 0 1-.35-.557",
    transform: "translate(-2.868 -1.834)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2742",
    d: "M21.459 7.585a2.523 2.523 0 0 1-.336.547 6.559 6.559 0 0 1 2.059 1.057 3.748 3.748 0 0 1 .8-.145 7.171 7.171 0 0 0-2.523-1.459",
    transform: "translate(-7.074 -1.824)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2743",
    d: "M16.883 5.649a1.894 1.894 0 0 0 1.883-1.9C18.766 2.692 16.883 0 16.883 0S15 2.692 15 3.744a1.894 1.894 0 0 0 1.883 1.9m.838-2.525a.489.489 0 1 1-.484.49.487.487 0 0 1 .484-.49",
    transform: "translate(-4.794 1)",
    style: {
      fill: "#f5f5f5"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFertilizerX24);
export default __webpack_public_path__ + "static/media/fertilizer-x24.00407d5f56c3fc963118fe4b3ae0cc94.svg";
export { ForwardRef as ReactComponent };